import { useDeviceContext } from '@/contexts/DeviceContext';
import Footer from '@/layout/Footer';
import { LayoutProvider, useLayout } from '@/layout/LayoutContext';
import MobileHeader from '@/layout/MobileHeader';
import PageContainer from '@/layout/PageContainer';
import SlideMenu from '@/layout/SlideMenu';
import { cn } from '@/utils/cn';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface LayoutProps {
  children: React.ReactNode;
}

const AppShellContent: React.FC<LayoutProps> = ({ children }: LayoutProps) => {
  const { isTouch } = useDeviceContext();
  const { i18n } = useTranslation();
  const { showFooter, showHeader } = useLayout();
  const [slideMenuOpen, setSlideMenuOpen] = useState(false);

  return (
    <>
      <div
        key={`language-${i18n.language}`} // Force re-render on language change
        className={cn(
          'flex min-h-screen max-w-screen flex-col',
          isTouch ? 'min-w-mobile-min' : '',
        )}
      >
        <div className="flex flex-1 flex-col">
          {isTouch && showHeader && (
            <>
              <SlideMenu isOpen={slideMenuOpen} toggle={setSlideMenuOpen} />
              <MobileHeader slideMenuToggle={setSlideMenuOpen} />
            </>
          )}
          <PageContainer>{children}</PageContainer>
        </div>
      </div>
      {showFooter && <Footer />}
    </>
  );
};

const AppShell: React.FC<LayoutProps> = ({ children }: LayoutProps) => {
  return (
    <LayoutProvider>
      <AppShellContent>{children}</AppShellContent>
    </LayoutProvider>
  );
};

export default AppShell;
